export default __webpack_public_path__ + "locales/zh-CN/FilesSettings.json?hash=70d9b9e1ef381273287d03175f6e93b6";